import {  Component, ContentChildren, OnDestroy, QueryList, Output, EventEmitter,  OnInit,  Input,  NgZone,
   ViewChild, Inject } from '@angular/core';

@Component({
  selector: 'ssg-side-filter',
  templateUrl: './side-filter.component.html',
  styleUrls: ['./side-filter.component.less'],
})
export class SideFilterComponent implements OnInit {
  @Output() apply: EventEmitter<any>;
  @Output() reset: EventEmitter<any>;
  @Output() toggle: EventEmitter<boolean>;
  @ViewChild('drawer') drawer;
  @Input() isInvalid = false;
  @Input() isDisabled = false;
  isDrawerOpen = false;

  showFilters = false;

  constructor(private readonly zone: NgZone) {
    this.apply = new EventEmitter<any>();
    this.reset = new EventEmitter<any>();
    this.toggle = new EventEmitter<boolean>();
  }

  ngOnInit() {}

  async triggerTaskDrawer() {
    await this.drawer.triggerDrawer();
  }

  async taskDrawerOpen() {
    this.showFilters = true;
  }

  async toggleFilters() {
    const isFilterOpen = !this.showFilters;
    if (isFilterOpen) {
      await this.triggerTaskDrawer();
    }
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  applyFilter() {
    this.apply.emit();
  }

  resetFilter() {
    this.reset.emit();
  }

  async taskDrawerDidClosed() {
    this.showFilters = false;
  }
}
